module.exports = __webpack_public_path__ + "static/media/game-selection-bg.df5ab5e6.webp";